import React, { useMemo } from 'react';
import logo from '../../assets/images/logo.jpg';
import logoThrive from '../../assets/images/logoLQG360.png';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Container,
    SidebarHeader,
    SidebarBody,
    SidebarFooter,
    MenuItem,
    MenuItemLabel,
    SubMenuItem,
    ChevronIcon,
    ActiveIndicator
} from './style';
import { FiX } from 'react-icons/fi';
import { FaChevronRight, FaChevronDown } from 'react-icons/fa';
import { useAuth } from '../../hooks/auth';

import RoutesList from '../../routes/routesList';

const Sidebar = ({ active, setActive, openMenu, setOpenMenu }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, userRoles } = useAuth();

    const sidebarMenuItems = useMemo(() => {       
        return RoutesList.filter(item => item.showInSidebar && (item.allowedRoles == null || item.allowedRoles?.some(role => userRoles?.includes(role))) && (!item?.onlyGlobal || (item?.onlyGlobal && user?.companyID == null) || item.justInfoHolder));
    }, [userRoles, user]);

    const isActiveRoute = (path) => {
        if (!path) return false;
        const currentPath = location.pathname;
        
        // Exact match
        if (currentPath === path) return true;
        
        // Handle routes with dynamic parameters (e.g., /Report/:operation/:moduleName)
        // Convert route pattern to regex
        const routePattern = path.replace(/:[^/]+/g, '[^/]+').replace(/\?/g, '');
        const regex = new RegExp(`^${routePattern}(/.*)?$`);
        if (regex.test(currentPath)) return true;
        
        // Check if current path starts with the route path (for nested routes)
        // Only if path doesn't contain dynamic parameters
        if (!path.includes(':') && path !== '/' && currentPath.startsWith(path)) {
            // Ensure it's not a partial match (e.g., /dashboard shouldn't match /dashboard-settings)
            const nextChar = currentPath[path.length];
            if (!nextChar || nextChar === '/') return true;
        }
        
        return false;
    };

    const isChildActive = (children) => {
        if (!children || !Array.isArray(children)) return false;
        return children.some(child => isActiveRoute(child.path));
    };

    return (
        <Container className={(active ? "show" : "hide")}>
            <SidebarHeader>
                <div className="close-button">
                    <FiX onClick={() => { setActive(!active) }} alt="Close menu" size={22} />
                </div>
                <div className='li-logo'>
                    <img src={logoThrive} alt="Logo Thrive Digital" />
                </div>
            </SidebarHeader>
            <SidebarBody>
                {active && <ul>
                    {sidebarMenuItems.map(item => {
                        const isActive = isActiveRoute(item.path) || (item.childrens && isChildActive(item.childrens));
                        const isMenuOpen = openMenu === item.label;
                        
                        return (
                            <React.Fragment key={item.label}>
                                <MenuItem 
                                    $isActive={isActive}
                                    $isMenu={item.isMenu}
                                    onClick={() => {
                                        if (item.isMenu) {
                                            localStorage.setItem('@QualityApp:openMenu', openMenu == item.label ? null : item.label);
                                            setOpenMenu(openMenu == item.label ? null : item.label);
                                        } else {
                                            setActive(false);
                                            navigate(item.path);
                                        }
                                    }}
                                >
                                    {isActive && <ActiveIndicator />}
                                    {item.isMenu && (
                                        <ChevronIcon $isOpen={isMenuOpen}>
                                            {isMenuOpen ? <FaChevronDown size={12} /> : <FaChevronRight size={12} />}
                                        </ChevronIcon>
                                    )}
                                    <MenuItemLabel $isActive={isActive} $hasChevron={item.isMenu}>
                                        {item.label}
                                    </MenuItemLabel>
                                </MenuItem>
                                {item.childrens && (
                                    <ul className={`submenu ${isMenuOpen ? 'open' : ''}`}>
                                        {item.childrens.filter(children => 
                                            children.showInSidebar && 
                                            (children.allowedRoles == null || children.allowedRoles?.some(role => userRoles?.includes(role))) && 
                                            (!children?.onlyGlobal || (children?.onlyGlobal && user?.companyID == null))
                                        ).map((children, index) => {
                                            const isChildActiveRoute = isActiveRoute(children.path);
                                            return (
                                                <SubMenuItem 
                                                    key={`${children.label}-${index}`}
                                                    $isActive={isChildActiveRoute}
                                                    $index={index}
                                                    onClick={() => {
                                                        setActive(false);
                                                        navigate(children.path);
                                                    }}
                                                >
                                                    {isChildActiveRoute && <ActiveIndicator $isSubItem={true} />}
                                                    <MenuItemLabel $isActive={isChildActiveRoute} $isSubItem={true}>
                                                        {children.label}
                                                    </MenuItemLabel>
                                                </SubMenuItem>
                                            );
                                        })}
                                    </ul>
                                )}
                            </React.Fragment>
                        );
                    })}
                </ul>}
            </SidebarBody>
        </Container>
    );
}

export default Sidebar;
